import { useEffect, useState } from "react";
import axiosClient from "../HTTPServices/apiClient";
import RequestMsg from "../Models/RequestMsg";

const HTTPServices = {
  get2: async function (urlPostFix) {
    console.log("HTTP get call to url:  " + urlPostFix);
    // setLoading(true);

    await axiosClient
      .get(urlPostFix)
      .then((response) => {
        // setOutput(response.data.responseObj);
        // debugger;
        console.log(
          "Response: ===== > " +
            urlPostFix +
            " ---- " +
            JSON.stringify(response.data.responseObj)
        );
      })
      .catch((err) => {
        // setError(err);
      })
      .finally(() => {
        // setLoading(false);
      });

    // return output;
  },

  get: async function (urlPostFix) {
    console.log("HTTP get call to url :  " + urlPostFix);
    let output;

    await axiosClient
      .get(urlPostFix)
      .then((response) => {
        // setOutput(response.data.responseObj);
        output = response.data.responseObj;
        // debugger;
        console.log(
          "Response: ===== > " +
            urlPostFix +
            " ---- " +
            JSON.stringify(response.data.responseObj)
        );

        //console.log("returning data ---> " + response.data.responseObj);
        //return response.data.responseObj;
      })
      .catch((err) => {
        // setError(err);
      })
      .finally(() => {
        //setLoading(false);
      });

    console.log("returning data Finally ---> " + JSON.stringify(output));
    return output;
  },

  post_ReturnFullObject: async function (urlPostFix, data) {
    console.log("HTTP post call to url and data:  " + urlPostFix + ", " + data);
    let output;
    let reqMsg = new RequestMsg();
    reqMsg.RequestObj = data;
    reqMsg.UserID = "";

    await axiosClient
      .post(urlPostFix, JSON.stringify(reqMsg))
      // .then((response) => response.json())
      .then((response) => {
        // setOutput(response.data.responseObj);
        output = response.data;
        // debugger;
        console.log(
          "response.data: ===== > " + urlPostFix + " ---- " + response.data
        );

        // console.log("returning data ---> " + response.data.responseObj);
        return response.data;
      })
      .catch((err) => {
        // setError(err);
      })
      .finally(() => {
        //setLoading(false);
      });

    console.log("returning data Finally ---> " + JSON.stringify(output));
    return output;
  },

  post: async function (urlPostFix, data) {
    console.log("HTTP post call to url and data:  " + urlPostFix + ", " + data);
    let output;
    //  const [output, setOutput] = useState(null); // this create error. Hence avoit it
    // setLoading(true);

    // const requestOptions = {
    //   method: "POST",
    //   headers: { "Content-Type": "application/json" },
    //   body: JSON.stringify({ title: "React POST Request Example" }),
    // };
    // fetch("https://reqres.in/api/posts", requestOptions)
    //   .then((response) => response.json())
    //   .then((data) => this.setState({ postId: data.id }));
    let reqMsg = new RequestMsg();
    reqMsg.RequestObj = data;
    // reqMsg.CompanyID = -1;
    // reqMsg.ID = -1;
    reqMsg.UserID = "";

    console.log("Request: ===== > " + JSON.stringify(reqMsg));

    await axiosClient
      .post(urlPostFix, JSON.stringify(reqMsg))
      // .then((response) => response.json())
      .then((response) => {
        // setOutput(response.data.responseObj);
        output = response.data.responseObj;
        // debugger;
        console.log(
          "Response: ===== > " +
            urlPostFix +
            " ---- " +
            JSON.stringify(response.data.responseObj)
        );

        // console.log("returning data ---> " + response.data.responseObj);
        return response.data.responseObj;
      })
      .catch((err) => {
        // setError(err);
      })
      .finally(() => {
        //setLoading(false);
      });

    console.log("returning data Finally ---> " + JSON.stringify(output));
    return output;
  },
};

export default HTTPServices;
